module.exports = __webpack_public_path__ + "static/media/getbarLogo.1648189a.png";